// import React, { useMemo, useState } from "react";
// import "../assets/css/Cgt.css";
// import { Edit, Trash } from "lucide-react";
// import { toast } from "react-toastify";

// const CgtManagement = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(1);
//   const [loading,setLoading]=useState(false)
//   const ITEMS_PER_PAGE_OPTIONS = [1, 2, 4];
//   const [formData, setFormData] = useState({
//     branch: "",
//     officer: "",
//     description: "",
//     startDate: "",
//     center: "",
//     group: "",
//   });

//   const [data, setData] = useState([
//     {
//       id: 1,
//       cgtId: "CGT001",
//       center: "Center A",
//       group: "Group X",
//       description: "Initial CGT session",
//       startDate: "2025-10-01",
//       officer: "Ravi Kumar",
//     },
//     {
//       id: 2,
//       cgtId: "CGT002",
//       center: "Center B",
//       group: "Group Y",
//       description: "Follow-up CGT",
//       startDate: "2025-10-03",
//       officer: "Anita Sharma",
//     },
//   ]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleAdd = () => {
//     if (
//       !formData.branch ||
//       !formData.officer ||
//       !formData.center ||
//       !formData.group
//     ) {
//       toast.warn("Please fill all required fields.");
//       return;
//     }

//     const newData = {
//       id: data.length + 1,
//       cgtId: `CGT00${data.length + 1}`,
//       center: formData.center,
//       group: formData.group,
//       description: formData.description,
//       startDate: formData.startDate,
//       officer: formData.officer,
//     };
//     setData([...data, newData]);
//     setFormData({
//       branch: "",
//       officer: "",
//       description: "",
//       startDate: "",
//       center: "",
//       group: "",
//     });
//   };

//   // Search + Pagination
//   const filteredData = useMemo(() => {
//     return data.filter((item) =>
//       Object.values(item)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase())
//     );
//   }, [data, searchQuery]);

//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);

//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };
//   return (
//     <div className="group-cgt-container">
//       <h1 className="group-cgt-heading">Group CGT</h1>

//       {/* ================= FORM ================= */}
//       <section className="group-cgt-top">
//         <form className="group-cgt-form" onSubmit={handleAdd}>
//           <div className="group-cgt-form-section">
//             <div className="group-cgt-form-input-fields">
//               <label>Branch</label>
//               <select
//                 name="branch"
//                 value={formData.branch}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Branch</option>
//                 <option value="Branch A">Branch A</option>
//                 <option value="Branch B">Branch B</option>
//               </select>
//             </div>

//             <div className="group-cgt-form-input-fields">
//               <label>Wealth Officer</label>
//               <select
//                 name="officer"
//                 value={formData.officer}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Officer</option>
//                 <option value="Ravi Kumar">Ravi Kumar</option>
//                 <option value="Anita Sharma">Anita Sharma</option>
//               </select>
//             </div>

//             <div className="group-cgt-form-input-fields">
//               <label>Description</label>
//              <input
//                type="text"
//                name="description"
//                value={formData.description}
//                onChange={handleChange}
//                placeholder="Enter description"
//              />
//             </div>

//             <div className="group-cgt-form-input-fields">
//               <label>CGT Start Date</label>
//              <input
//                type="date"
//                name="startDate"
//                value={formData.startDate}
//                onChange={handleChange}
//              />
//             </div>

//             <div className="group-cgt-form-input-fields">
//               <label>Center</label>
//              <input
//                type="text"
//                name="center"
//                value={formData.center}
//                onChange={handleChange}
//                placeholder="Enter Center"
//              />
//             </div>

//             <div className="group-cgt-form-input-fields">
//               <label>Group</label>
//             <select name="group" value={formData.group} onChange={handleChange}>
//               <option value="">Select Group</option>
//               <option value="Group X">Group X</option>
//               <option value="Group Y">Group Y</option>
//             </select>
//             </div>
//           </div>

//           <div className="group-cgt-form-submit-btn">
//              <button>Add</button>
//           </div>
//         </form>
//       </section>

//       {/* ================= REPORT SECTION ================= */}
//       <div className="group-cgt-report-container">
//         <h1>CGT Details</h1>
//         <div className="group-cgt-report-filter-div">
//           <input
//             type="text"
//             placeholder="Search..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />

//           <div className="group-cgt-filter">
//             <label>Show </label>
//             <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
//               {ITEMS_PER_PAGE_OPTIONS.map((num) => (
//                 <option key={num} value={num}>
//                   {num}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//         </div>

//         <div className="group-cgt-report-table-container">
//           <table className="group-cgt-report-table">
//             <thead>
//               <tr>
//                 <th>Sr. No.</th>
//                <th>CGT ID</th>
//                <th>Center Name</th>
//                <th>Group Name</th>
//                <th>Description</th>
//                <th>CGT Start Date</th>
//                <th>CGT Taken By</th>
//                <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((item, index) => (
//                   <tr key={item.id}>
//                     <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                     <td>{item.cgtId}</td>
//                  <td>{item.center}</td>
//                  <td>{item.group}</td>
//                  <td>{item.description}</td>
//                  <td>{item.startDate}</td>
//                  <td>{item.officer}</td>
//                 <td className="group-action-btns">
//                       <Edit
//                         className="edit-icon"
//                       />
//                       <Trash
//                         className="delete-icon"
//                       />
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   {loading ? (
//                     <td colSpan="11" style={{ textAlign: "center" }}>
//                       Loading...
//                     </td>
//                   ) : (
//                     <td colSpan="11" style={{ textAlign: "center" }}>
//                       No results found
//                     </td>
//                   )}
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {filteredData.length > itemsPerPage && (
//           <div className="group-cgt-pagination-div">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage(currentPage - 1)}
//             >
//               ⬅ Prev
//             </button>

//             <span>
//               {" "}
//               Page {currentPage} of {totalPages}{" "}
//             </span>

//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage(currentPage + 1)}
//             >
//               Next ➡
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CgtManagement;




/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import "../assets/css/Cgt.css";
import { Edit, Trash, CheckCircle, ArrowRightIcon, ArrowLeftIcon } from "lucide-react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const CgtManagement = () => {
  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const navigate=useNavigate()

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPagesState, setTotalPagesState] = useState(1); 
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100, "All"];

  const [data, setData] = useState([]);

  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCgt, setSelectedCgt] = useState(null);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchCgt = async () => {
    if (!profile?.superAdminId) return;
    setLoading(true);
    try {
      const isAll = itemsPerPage === "All";
      const limitValue = isAll ? 100000 : itemsPerPage;
      
      const res = await axios.get(`https://payyug.in/api/cgt/list`, {
        params: {
          superAdminId: profile?.superAdminId,
          page: isAll ? 1 : currentPage,
          limit: limitValue,
        },
      });

      const fetchedData = res?.data?.data || [];
      setData(fetchedData);
      
      const apiPage = res?.data?.pagination?.page || 1;
      setCurrentPage(apiPage);

      const totalItems = res?.data?.pagination?.total || fetchedData.length;
      const calculatedPages = isAll ? 1 : Math.ceil(totalItems / limitValue);
      setTotalPagesState(calculatedPages || 1);

    } catch (err) {
      toast.error(err?.response?.data?.message || "Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCgt();
  }, [profile, currentPage, itemsPerPage]);

  const handleOpenApproveModal = (item) => {
    setSelectedCgt(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCgt(null);
  };

  const handleApproveSubmit = async () => {
    if (!selectedCgt) return;

    setSubmitting(true);
    try {
      const payload = {
        cgtId: Number(selectedCgt.id),
        updateBy: Number(profile?.id || 2),
      };

      const res = await axios.post(
        `https://payyug.in/api/cgt/approve`,
        payload,
      );

      toast.success(res?.data?.message || "CGT approved!");
      handleCloseModal();
      fetchCgt();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to approve CGT row.");
    } finally {
      setSubmitting(false);
    }
  };

  const filteredData = useMemo(() => {
    if (!searchQuery) return data;
    return data.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()),
    );
  }, [data, searchQuery]);

  const handleItemsPerPageChange = (e) => {
    const val = e.target.value;
    setItemsPerPage(val === "All" ? "All" : Number(val));
    setCurrentPage(1); 
  };

  return (
    <div className="group-cgt-container">
       {/* Back wrapper */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <ArrowLeftIcon
          onClick={() => navigate(-1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />

        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          Group CGT
        </h2>

        <ArrowRightIcon
          onClick={() => navigate(1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />
      </div>

      {/* ================= REPORT SECTION ================= */}
      <div className="group-cgt-report-container">
        <div className="group-cgt-report-filter-div">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <div className="group-cgt-filter">
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="group-cgt-report-table-container">
          <table className="group-cgt-report-table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>CGT ID</th>
                <th>Center Id</th>
                <th>Group Id</th>
                <th>Description</th>
                <th>CGT Start Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={item.id || index}>
                    <td>
                      
                      {itemsPerPage === "All" 
                        ? index + 1 
                        : (currentPage - 1) * itemsPerPage + index + 1}
                    </td>
                    <td>{item.CGTID}</td>
                    <td>{item.CenterId}</td>
                    <td>{item.groupId}</td>
                    <td>{item.Description}</td>
                    <td>
                      {item.CGTStartDate || item.CGT_StartDate
                        ? new Date(item.CGTStartDate || item.CGT_StartDate).toLocaleDateString("en-GB")
                        : "N/A"}
                    </td>
                    <td>{item.status}</td>
                    <td className="group-action-btns">
                      <button
                        disabled={item.status?.toLowerCase() === "approved"}
                        onClick={() => handleOpenApproveModal(item)}
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor:
                            item.status?.toLowerCase() === "approved"
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <CheckCircle
                          className="approve-icon"
                          style={{
                            color:
                              item.status?.toLowerCase() === "approved" ? "#c7f7ca" : "green",
                            marginRight: "8px",
                          }}
                        />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {itemsPerPage !== "All" && totalPagesState > 1 && (
          <div className="group-cgt-pagination-div">
            <button
              disabled={currentPage === 1 || loading}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            >
              &larr; Prev
            </button>

            <span>
              Page {currentPage} of {totalPagesState}
            </span>

            <button
              disabled={currentPage === totalPagesState || loading}
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPagesState))
              }
            >
              Next &rarr;
            </button>
          </div>
        )}
      </div>

      {/* ================= APPROVAL POPUP MODAL ================= */}
      {isModalOpen && (
        <div className="modal-overlay" style={modalStyles.overlay}>
          <div className="modal-content" style={modalStyles.content}>
            <h2>Approve CGT Confirmation</h2>
            <hr />
            <p style={{ margin: "15px 0" }}>
              Are you sure you want to approve CGT ID:{" "}
              <strong>{selectedCgt?.CGTID || selectedCgt?.cgtId}</strong>?
            </p>

            {/* <div style={modalStyles.preview}>
              <strong>Payload Preview:</strong>
              <pre style={{ margin: "5px 0 0 0" }}>
                {JSON.stringify(
                  { cgtId: selectedCgt?.id, updateBy: profile?.id || 2 },
                  null,
                  2,
                )}
              </pre>
            </div> */}

            <div style={modalStyles.btnContainer}>
              <button
                onClick={handleCloseModal}
                disabled={submitting}
                style={modalStyles.cancelBtn}
              >
                Cancel
              </button>
              <button
                onClick={handleApproveSubmit}
                disabled={submitting}
                style={modalStyles.confirmBtn}
              >
                {submitting ? "Approving..." : "Confirm Approval"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  content: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "400px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  preview: {
    backgroundColor: "#f4f4f5",
    padding: "10px",
    borderRadius: "4px",
    fontSize: "12px",
    fontFamily: "monospace",
    marginBottom: "15px",
  },
  btnContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  cancelBtn: {
    padding: "8px 16px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
  confirmBtn: {
    padding: "8px 16px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#22c55e",
    color: "#fff",
    cursor: "pointer",
  },
};

export default CgtManagement;